export const PlinkoSoundNames = {
  win: 'win',
  bet: 'bet',
  bumping: 'bumping',
  bumpingMore2: 'bumpingMore2',
  bumpingManyTurbo: 'bumpingManyTurbo',
};
export const PlinkoSoundPath = [
  {
    src: 'audio/plinko/win.mp3',
    name: PlinkoSoundNames.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/plinko/bet.mp3',
    name: PlinkoSoundNames.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/plinko/bumping_10_turbo.mp3',
    name: PlinkoSoundNames.bumpingManyTurbo,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/plinko/pin_bumping_more2.mp3',
    name: PlinkoSoundNames.bumpingMore2,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/plinko/pin_bumping.mp3',
    name: PlinkoSoundNames.bumping,
    autoplay: false,
    html5: true,
  },
];
